import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; //
import API_BASE_URL from "../config";

export default function Useradd() {
  const [userdata, setUserData] = useState([]);
  const [userprofpic, setUserProfPic] = useState([]);
  const [role, setRole] = useState([]);
  const [desig, setDesig] = useState([]);
  const [fileconfig, setFileConfig] = useState([]);
  const [ispwdchanged, setIsPwdChanged] = useState(false);
  let userNavigate = useNavigate();

  useEffect(() => {
    const getUser = async () => {
      const user_name = sessionStorage.getItem("edit_user_name")
        ? sessionStorage.getItem("edit_user_name")
        : "";
      if (user_name !== "") {
        const resUsers = await fetch(
          `${API_BASE_URL}GetAllUsers.php/${user_name}`
        );
        const resuserjson = await resUsers.json();
        setUserData(await resuserjson.data[0]);
      }
    };
    getUser();
  }, []);

  //Fetch all role
  useEffect(() => {
    const getRole = async () => {
      const resDt = await fetch(
        `${API_BASE_URL}GetMasterData.php/4`
      );
      const resdtjson = await resDt.json();
      setRole(await resdtjson.data);
    };
    getRole();
  }, []);

  //Fetch file settings
  useEffect(() => {
    const getFileConfig = async () => {
      const resDt = await fetch(
        `${API_BASE_URL}GetMasterData.php/5`
      );
      const resdtjson = await resDt.json();
      setFileConfig(await resdtjson.data);
    };
    getFileConfig();
  }, []);

  //Fetch all designation
  useEffect(() => {
    const getDesig = async () => {
      const resDt = await fetch(
        `${API_BASE_URL}GetMasterData.php/6`
      );
      const resdtjson = await resDt.json();
      setDesig(await resdtjson.data);
    };
    getDesig();
  }, []);

  const SaveUser = () => {
    //console.log(userdata);
    var err_msg = validateform();
    if (err_msg === "" || err_msg === "undefined") {
      Save();
      alert("User successfully saved!");
      userNavigate("/usersearch");
    } else {
      alert(err_msg);
    }
  };

  const Save = async () => {
    const userFormData = new FormData();
    userFormData.append("userdata", JSON.stringify(userdata));
    userFormData.append("userprofpic", userprofpic);

    const templsaver = await axios.post(
      `${API_BASE_URL}InsertUser.php`,
      userFormData,
      {
        hearders: { "Content-Type": "multipart/form-data" },
      }
    );

    if (templsaver.data.success) {
      setTimeout(() => {}, 2000);
    }
    console.log(userprofpic);
  };

  const validateform = () => {
    var strErr_Msg = "";
    console.log(ispwdchanged);
    if (!userdata.user_name) {
      strErr_Msg = strErr_Msg + "User Name is missing";
      return strErr_Msg;
    }
    if (!userdata.user_id) {
      if (!userdata.pwd || !userdata.conf_pwd) {
        strErr_Msg = strErr_Msg + "User Password is missing";
        return strErr_Msg;
      }
      if (userdata.pwd !== userdata.conf_pwd) {
        strErr_Msg =
          strErr_Msg + "Password is not matching with confirm password";
        return strErr_Msg;
      }
    } else {
      if (ispwdchanged) {
        if (!userdata.pwd || !userdata.conf_pwd) {
          strErr_Msg = strErr_Msg + "User Password is missing";
          return strErr_Msg;
        }
        if (userdata.pwd !== userdata.conf_pwd) {
          strErr_Msg =
            strErr_Msg + "Password is not matching with confirm password";
          return strErr_Msg;
        }
      }
    }
    if (!userdata.role_id) {
      strErr_Msg = strErr_Msg + "Role is missing";
      return strErr_Msg;
    }
    if (!userdata.f_name) {
      strErr_Msg = strErr_Msg + "First Name is missing";
      return strErr_Msg;
    }
    if (!userdata.l_name) {
      strErr_Msg = strErr_Msg + "Last Name is missing";
      return strErr_Msg;
    }
    if (!userdata.mobile_num) {
      strErr_Msg = strErr_Msg + "Mobile is missing";
      return strErr_Msg;
    }
    if (!userdata.e_mail) {
      strErr_Msg = strErr_Msg + "Email Id is missing";
      return strErr_Msg;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(userdata.e_mail)) {
        strErr_Msg = strErr_Msg + "Email Id is not correct";
        return strErr_Msg;
      }
    }

    if (userdata.prof_pic) {
      const allowedTypes = fileconfig[1].val.split(",");
      if (userdata.prof_pic.size > fileconfig[0].val) {
        strErr_Msg =
          strErr_Msg +
          "Profile pic size should not be greater than " +
          fileconfig[0].val / 1024 +
          "KB.";
        return strErr_Msg;
      }

      if (!allowedTypes.includes(userdata.prof_pic.type)) {
        strErr_Msg = strErr_Msg + "Invalid profile pic type";
        return strErr_Msg;
      }
    }
    return strErr_Msg;
  };
  return (
    <>
      <div className="row container-xl mx-auto">
        <div className="col-xl-4">
          {/* Profile picture card*/}
          <div className="card mb-4 mb-xl-0">
            <div className="card-header">Profile Picture</div>
            <div className="card-body text-center">
              {/* Profile picture image*/}
              <img
                className="img-profile rounded-circle"
                src={
                  userdata.prof_pic_path
                    ? userdata.prof_pic_path
                    : "./img/profile-1.png"
                }
                alt=""
              />
              {/* Profile picture help block*/}
              <div className="small font-italic text-muted mb-4">
                JPG or PNG no larger than 200 KB
              </div>

              <input
                id="prof_pic"
                className="file-upload-button"
                type="file"
                accept="image/*"
                onChange={(e) => setUserProfPic(e.target.files[0])}
              />
            </div>
          </div>
        </div>
        <div className="col-xl-8">
          {/* Account details card*/}
          <div className="card mb-4">
            <div className="card-header">
              <i className="fas fa-user"></i>&nbsp;User Details
            </div>
            <div className="card-body">
              <form>
                {/* Form Row*/}
                <div className="row gx-3 mb-3">
                  <div className="col-md-12">
                    <label className="btn-outline-danger">*</label>
                    <label className="small mb-1" for="inputUserId">
                      User Name
                    </label>
                    <input
                      className="form-control"
                      id="user_name"
                      type="text"
                      placeholder="User Name"
                      onChange={(e) =>
                        setUserData({ ...userdata, user_name: e.target.value })
                      }
                      value={userdata.user_name}
                      readOnly={!userdata.user_id ? false : true}
                    />
                  </div>
                </div>
                <div className="row gx-3 mb-3">
                  <div className="col-md-12">
                    <label className="btn-outline-danger">*</label>
                    <label className="small mb-1" for="inputPwd">
                      Password
                    </label>
                    <input
                      className="form-control"
                      id="pwd"
                      type="password"
                      placeholder="Password"
                      onChange={(e) => (
                        setUserData({ ...userdata, pwd: e.target.value }),
                        userdata.user_id ? setIsPwdChanged(true) : ""
                      )}
                      value={userdata.pwd}
                      maxLength={12}
                      minLength={12}
                    />
                  </div>
                </div>
                <div className="row gx-3 mb-3">
                  <div className="col-md-12">
                    <label className="small mb-1" for="inputCnPwd">
                      Confirm Password
                    </label>
                    <input
                      className="form-control"
                      id="conf_pwd"
                      type="text"
                      placeholder="Confirm Password"
                      onChange={(e) =>
                        setUserData({ ...userdata, conf_pwd: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="row gx-3 mb-3">
                  <div className="col-md-6">
                    <label className="btn-outline-danger">*</label>
                    <label className="small mb-1" for="ddlRole">
                      Role
                    </label>
                    <select
                      className="custom-select mr-sm-2"
                      id="role_id"
                      onChange={(e) =>
                        setUserData({ ...userdata, role_id: e.target.value })
                      }
                      value={userdata.role_id}
                    >
                      <option selected>Choose...</option>
                      {role?.map((dtitem, index) => (
                        <option key={dtitem.key} value={dtitem.key}>
                          {dtitem.val}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="small mb-1" for="ddlDesig">
                      Designation
                    </label>
                    <select
                      className="custom-select mr-sm-2"
                      id="desig_id"
                      onChange={(e) =>
                        setUserData({ ...userdata, desig_id: e.target.value })
                      }
                      value={userdata.desig_id}
                    >
                      <option selected>Choose...</option>
                      {desig?.map((dtitem, index) => (
                        <option key={dtitem.key} value={dtitem.key}>
                          {dtitem.val}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="row gx-3 mb-3">
                  {/* Form Group (first name)*/}
                  <div className="col-md-4">
                    <label className="btn-outline-danger">*</label>
                    <label className="small mb-1" for="inputFirstName">
                      First Name
                    </label>
                    <input
                      className="form-control"
                      id="f_name"
                      type="text"
                      placeholder="First Name"
                      onChange={(e) =>
                        setUserData({ ...userdata, f_name: e.target.value })
                      }
                      value={userdata.f_name}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="small mb-1" for="inputMidName">
                      Middle Name
                    </label>
                    <input
                      className="form-control"
                      id="m_name"
                      type="text"
                      placeholder="Middle Name"
                      onChange={(e) =>
                        setUserData({ ...userdata, m_name: e.target.value })
                      }
                      value={userdata.m_name}
                    />
                  </div>
                  {/* Form Group (last name)*/}
                  <div className="col-md-4">
                    <label className="btn-outline-danger">*</label>
                    <label className="small mb-1" for="inputLastName">
                      Last Name
                    </label>
                    <input
                      className="form-control"
                      id="l_name"
                      type="text"
                      placeholder="Last Name"
                      onChange={(e) =>
                        setUserData({ ...userdata, l_name: e.target.value })
                      }
                      value={userdata.l_name}
                    />
                  </div>
                </div>
                {/* Form Group (email address)*/}
                <div className="row gx-3 mb-3">
                  <div className="col-md-4">
                    <label className="btn-outline-danger">*</label>
                    <label className="small mb-1" for="inputMobile">
                      Mobile
                    </label>
                    <input
                      className="form-control"
                      id="mobile_num"
                      type="mobile"
                      placeholder="Mobile"
                      onChange={(e) =>
                        setUserData({ ...userdata, mobile_num: e.target.value })
                      }
                      value={userdata.mobile_num}
                      maxLength={10}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="small mb-1" for="inputAltmobile">
                      Alternate Mobile
                    </label>
                    <input
                      className="form-control"
                      id="alt_mobile_num"
                      type="altmobile"
                      placeholder="Alternate Mobile"
                      onChange={(e) =>
                        setUserData({
                          ...userdata,
                          alt_mobile_num: e.target.value,
                        })
                      }
                      value={userdata.alt_mobile_num}
                      maxLength={10}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="btn-outline-danger">*</label>
                    <label className="small mb-1" for="inputEmailAddress">
                      Email
                    </label>
                    <input
                      className="form-control"
                      id="e_mail"
                      type="email"
                      placeholder="Email"
                      onChange={(e) =>
                        setUserData({ ...userdata, e_mail: e.target.value })
                      }
                      value={userdata.e_mail}
                    />
                  </div>
                </div>
                {/* Form Group (Roles)*/}
                {/* Submit button*/}
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={() => SaveUser()}
                >
                  Save Changes
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
